
import { supabase } from "@/integrations/supabase/client";

/**
 * Sends data to the aggregator function, which will combine it
 * with other data sources and trigger the CFS process
 *
 * @param data Any data that needs to be aggregated and sent to CFS
 * @returns The response from the aggregator function
 */
export const triggerAggregator = async (data: any) => {
  try {
    const { data: response, error } = await supabase.functions.invoke('aggregator', {
      body: data
    });

    if (error) {
      console.error('Error triggering aggregator:', error);
      throw error;
    }

    return response;
  } catch (error) {
    console.error('Failed to trigger aggregator:', error);
    throw error;
  }
};
